import { useState } from 'react'
import { api } from '../../shared/api'
import { tg } from '../../shared/lib/telegram'
import { useList } from '../../shared/lib/useList'
import { Loading } from '../../shared/ui/Loading'
import { EmptyState } from '../../shared/ui/EmptyState'
import { localInput, money } from '../../shared/lib/format'
import type { Item } from '../../shared/types'

interface ItemsListProps {
  version: number
  refresh: () => void
  onSchedule: () => void
}

export function ItemsList({ version, refresh, onSchedule }: ItemsListProps) {
  const [rows, error, setError] = useList(() => api.items(), version)
  const [picking, setPicking] = useState<number | null>(null)

  if (error) return <div className="error">{error}</div>
  if (!rows) return <Loading />
  if (rows.length === 0) {
    return (
      <EmptyState title="Ещё ничего не заведено">
        Открой вкладку «Новый» и собери первую карточку.
      </EmptyState>
    )
  }

  const put = async (item: Item, value: string | null) => {
    try {
      await api.schedule({ item_id: item.id, publish_at: value || null })
      tg?.HapticFeedback?.notificationOccurred('success')
      setPicking(null)
      refresh()
      onSchedule()
    } catch (e) {
      setError((e as Error).message)
    }
  }

  return (
    <>
      {rows.map((item) => (
        <article className="card" key={item.id}>
          <div className="row">
            {item.photos[0] ? (
              <img className="thumb" src={item.photos[0].url} alt="" />
            ) : (
              <div className="thumb empty">нет фото</div>
            )}
            <div className="grow">
              <div className="title">{item.title}</div>
              <div className="sub">
                {money(item.price)}
                {item.brand ? ` · ${item.brand}` : ''}
                {item.photos.length ? ` · ${item.photos.length} фото` : ''}
              </div>
            </div>
          </div>

          {picking === item.id ? (
            <PickTime onPick={(value) => put(item, value)} onCancel={() => setPicking(null)} />
          ) : (
            <div className="actions">
              <button className="chip accent" onClick={() => setPicking(item.id)}>
                В расписание
              </button>
            </div>
          )}
        </article>
      ))}
    </>
  )
}

function PickTime({
  onPick,
  onCancel,
}: {
  onPick: (value: string | null) => void
  onCancel: () => void
}) {
  // По умолчанию — через час: ставить объявление «прямо сейчас» из списка чаще
  // всего не то, чего хотят, а промахнуться в прошлое неприятно.
  const [value, setValue] = useState(localInput(new Date(Date.now() + 60 * 60 * 1000)))
  return (
    <>
      <label>Когда выложить (московское время)</label>
      <input type="datetime-local" value={value} onChange={(e) => setValue(e.target.value)} />
      <div className="actions">
        <button className="chip accent" onClick={() => onPick(value)}>
          Поставить
        </button>
        <button className="chip" onClick={() => onPick(null)}>
          Сразу
        </button>
        <button className="chip danger" onClick={onCancel}>
          Отмена
        </button>
      </div>
    </>
  )
}
